import { FULL_PAGE_AGENTS, FULL_PAGE_AGENTS_PAGE } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP } from '@townsquare/stat-sig/experiments';

export const agentsRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: FULL_PAGE_AGENTS_PAGE,
	path: FULL_PAGE_AGENTS,
	layout: 'home',
	nav4Layout: 'expanded',
	experimentGating: {
		experiments: [{ key: TOWNSQUARE_ENABLE_ROVO_HOME_APPIFICATION_EXP, cohort: 'test' }],
		behavior: { type: 'enabled' },
	},
});
